import type { GitHubConfig } from '../types';

const AUTH_KEY = 'dailylife_github_auth';
/** @deprecated only read for migration / prefill */
const LEGACY_PAT_KEY = 'dailylife_pat';

function normalizeConfig(config: GitHubConfig): GitHubConfig {
  const branch = config.branch.trim() || 'main';
  return {
    pat: config.pat.trim(),
    owner: config.owner.trim(),
    repo: config.repo.trim(),
    branch,
  };
}

export class AuthService {
  static save(config: GitHubConfig): void {
    const n = normalizeConfig(config);
    localStorage.setItem(
      AUTH_KEY,
      JSON.stringify({
        pat: n.pat,
        owner: n.owner,
        repo: n.repo,
        branch: n.branch,
      })
    );
    localStorage.removeItem(LEGACY_PAT_KEY);
  }

  /** Full GitHub settings + PAT, or null if not signed in. */
  static load(): GitHubConfig | null {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    try {
      const o = JSON.parse(raw) as Partial<GitHubConfig>;
      if (
        typeof o.pat === 'string' &&
        o.pat.trim() &&
        typeof o.owner === 'string' &&
        o.owner.trim() &&
        typeof o.repo === 'string' &&
        o.repo.trim()
      ) {
        return normalizeConfig({
          pat: o.pat,
          owner: o.owner,
          repo: o.repo,
          branch: typeof o.branch === 'string' ? o.branch : 'main',
        });
      }
    } catch {
      /* invalid JSON */
    }
    return null;
  }

  /** Token from older builds (PAT-only storage); used to prefill the sign-in form once. */
  static readLegacyPat(): string | null {
    const v = localStorage.getItem(LEGACY_PAT_KEY);
    return v?.trim() ? v.trim() : null;
  }

  static clear(): void {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(LEGACY_PAT_KEY);
  }

  static isAuthenticated(): boolean {
    return !!this.load();
  }
}
